import { defineComponent as A, computed as T, openBlock as s, createBlock as l, unref as b, withCtx as c, createElementVNode as L, createVNode as $, TransitionGroup as B, createElementBlock as k, Fragment as E, renderList as R, toRaw as r } from "vue";
import { RevPortal as F } from "@ds/components/Portal";
import { useToast as I } from "@ds/composables/useToast";
import { tw as n } from "../../utils/tailwind.js";
import N from "./components/ToastItem.vue2.js";
const P = { class: "pointer-events-none fixed inset-x-0 top-0 gap-12 p-24 md:p-16" }, q = /* @__PURE__ */ A({
  name: "RevToast",
  inheritAttrs: !1,
  __name: "Toast",
  props: {
    to: { default: "body" }
  },
  setup(d) {
    const i = I(), m = T(() => i.toasts), f = n`-translate-y-full opacity-0 md:translate-x-full md:translate-y-0`, p = n`ease-in-out motion-safe:transition-all motion-safe:duration-300`, u = n`absolute ease-in-out motion-safe:transition-all motion-safe:duration-150`, v = n`translate-y-[-200%] opacity-0 md:translate-x-full md:translate-y-0`, h = n`ease-in-out motion-safe:transition-all motion-safe:duration-150`;
    function C(o) {
      const e = o, { marginLeft: t, marginTop: a, width: x, height: g, visibility: w } = window.getComputedStyle(e);
      o.setAttribute(
        "style",
        `
    left: ${e.offsetLeft - parseInt(t, 10)}px;
    top: ${e.offsetTop - parseInt(a, 10)}px;
    width: ${x};
    height: ${g};
    visibility: ${w};
  `
      );
    }
    function y(o) {
      const e = r(o);
      e.onClose && e.onClose(), i.dismiss(e.id);
    }
    function _(o) {
      const e = r(o);
      e.onAction && e.onAction(), i.dismiss(e.id);
    }
    return (o, e) => (s(), l(b(F), { to: d.to }, {
      default: c(() => [
        L("div", P, [
          $(B, {
            class: "relative flex flex-col items-stretch gap-12 md:items-end",
            "enter-active-class": p,
            "enter-from-class": f,
            "leave-active-class": u,
            "leave-to-class": v,
            "move-class": h,
            tag: "div",
            onBeforeLeave: C
          }, {
            default: c(() => [
              (s(!0), k(E, null, R(m.value, (t) => (s(), l(N, {
                key: t.id,
                "action-label": t.actionLabel,
                description: t.description,
                duration: t.duration,
                icon: r(t.icon),
                "icon-props": t.iconProps,
                "icon-src": t.iconSrc,
                name: t.id,
                title: t.title,
                variant: t.variant,
                onAction: (a) => _(t),
                onClose: (a) => y(t)
              }, null, 8, ["action-label", "description", "duration", "icon", "icon-props", "icon-src", "name", "title", "variant", "onAction", "onClose"]))), 128))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["to"]));
  }
});
export {
  q as default
};
